<i [class]="name"></i>
